import { useMutation } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { updateIsAsyncLoading, updateHasUnsavedChanges } from 'modules/workflows/ducks';
import { WorkflowStatus } from 'modules/workflows/enums';
import { deleteWorkflowDraftMutation } from 'api/mutations/workflows';

const SUCCESS_MESSAGE = 'Success! Draft deleted.';
const ERROR_MESSAGE = 'An unknown error occurred';
const FAILURE_MESSAGE = 'Sorry, unable to delete draft.';

type useDeleteDraftProps = {
  variables: {
    id: number;
  };
  onSuccess?: () => void;
};

export const useDeleteDraft = () => {
  const dispatch = useDispatch();
  const [deleteWorkflowDraft] = useMutation(deleteWorkflowDraftMutation, {
    onError: () => {
      dispatch(updateIsAsyncLoading(false));
      return dispatch(addNegativeToastWithErrorId(ERROR_MESSAGE, 'useDeleteDraft'));
    },
  });

  return async ({ variables, onSuccess }: useDeleteDraftProps) => {
    dispatch(updateIsAsyncLoading(true));
    const { data } = await deleteWorkflowDraft({
      variables,
    });

    if (
      !data?.deleteWorkflowDraft?.status ||
      data?.deleteWorkflowDraft?.status !== WorkflowStatus.DELETED
    ) {
      dispatch(updateIsAsyncLoading(false));
      return dispatch(addNegativeToastWithErrorId(FAILURE_MESSAGE, 'useDeleteDraft'));
    }

    if (onSuccess) {
      dispatch(updateHasUnsavedChanges(false)); // update the state when deleting so the modal does not appear. kinda hacky.
      onSuccess();
    }

    dispatch(addPositiveToast(SUCCESS_MESSAGE));
  };
};
